import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../reducers/common.reducer";
import { getTransactionTypeService } from '../services/transaction.service';

const useTransactionTypeData = () => {
    const [transactionTypeData, setTransactionTypeData] = useState(null);

    const dispatch = useDispatch();

    async function getTransactionTypeData (signal) {
            
        try {
            dispatch(setIsLoading(true))
            let result = await getTransactionTypeService(signal);
            if(result.data) {
            setTransactionTypeData(result.data)
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    useEffect(() => {
            
        const controller = new AbortController();
        const signal = controller.signal;
        getTransactionTypeData(signal);

        return () => {
            controller.abort();
        }
    }, []);


    return [transactionTypeData, setTransactionTypeData]
}

export default useTransactionTypeData